function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function isDef (v) {
  return v !== undefined && v !== null
}

const _toString = Object.prototype.toString

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

export function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      const c = children[i]
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

function remove (arr, item) {
  if (arr.length) {
    const index = arr.indexOf(item)
    if (index > -1) {
      // console.log('remove', item)
      return arr.splice(index, 1)
    }
  }
}

function matches (pattern, key) {
  if (Array.isArray(pattern)) {
    // 兼容key被transition改变的情况
    return !!pattern.find(k => k === key || (key.startsWith('__transition') && key.endsWith(k)))
  }
  else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(key) > -1
  }
  else if (isRegExp(pattern)) {
    return pattern.test(key)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  // console.log('pruneCache')
  const {cache, keys, _vnode} = keepAliveInstance
  for (const key in cache) {
    const cachedNode = cache[key]
    if (cachedNode) {
      // const name = getComponentName(cachedNode.componentOptions)
      const cacheKey = cachedNode.key || getComponentName(cachedNode.componentOptions)
      if (cacheKey && !filter(cacheKey)) {
        pruneCacheEntry(cache, key, keys, _vnode)
      }
    }
  }
}

function pruneCacheEntry (
  cache, // VNodeCache,
  key, // string,
  keys, // Array<string>
  current, // VNode
) {
  const cached = cache[key]
  if (cached && (!current || cached.tag !== current.tag)) {
    cached.componentInstance.$destroy()
  }
  cache[key] = null
  remove(keys, key)
}

const patternTypes = [String, RegExp, Array]

export default {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number],
  },

  created () {
    // console.log('keepAlive created')
    this.cache = Object.create(null)
    this.keys = []
  },

  destroyed () {
    // console.log('keepAlive destroyed')
    for (const key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys)
    }
  },

  mounted () {
    this.$watch('include', val => {
      pruneCache(this, key => matches(val, key))
    })
    this.$watch('exclude', val => {
      pruneCache(this, key => !matches(val, key))
    })
  },

  render () {
    const slot = this.$slots.default
    const vnode = getFirstComponentChild(slot) || {}
    const componentOptions = vnode.componentOptions
    if (componentOptions) {
      // check pattern
      const cacheKey = vnode.key || getComponentName(componentOptions)
      const {include, exclude} = this
      // console.log('keepAliveVNode', vnode)
      if (
        // not included
        (include && (!cacheKey || !matches(include, cacheKey))) ||
        // excluded
        (exclude && cacheKey && matches(exclude, cacheKey))
      ) {
        return vnode
      }

      const {cache, keys} = this
      const key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? `::${componentOptions.tag}` : '')
        : vnode.key

      // console.log('keepAliveCache', cache, key, cache[key])
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance
        // make current key freshest
        remove(keys, key)
        keys.push(key)
      }
      else {
        cache[key] = vnode
        keys.push(key)
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode)
        }
      }

      vnode.data.keepAlive = true
    }
    return vnode || (slot && slot[0])
  },
}
